<template>
  <div class="form-page">
    <div class="form-input__wrap">
      <input
        v-if="showInput"
        :type="history[currentStep].field.type"
        inputmode="number"
        class="form-input"
        @keydown="handleKeydown"
        @change="handleChange"
        v-model="inputVal"
        :name="history[currentStep].name"
        v-bind:class="{error: history[currentStep].showError}"
        :placeholder="history[currentStep].field.placeholder"
        required>
      <span
        class="form-input-floating-label"
        v-bind:class="{error: history[currentStep].showError}"
      >{{history[currentStep].field.label}}</span>
    </div>
    <transition name="fade">
      <span class="error-message" v-if="history[currentStep].showError">
        {{history[currentStep].field.error}}
      </span>
    </transition>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import Inputmask from 'inputmask'

export default {
  name: 'DateField',
  data () {
    return {
      initValue: false,
      inputVal: '',
      newDesign: window.newDesign,
      im: {}
    }
  },
  computed: {
    isValid () {
      let regex = this.history[this.currentStep].field.reg
      let regPassed = new RegExp(regex).test(this.inputVal)
      if (regPassed) {
        let age = this.$store.getters.getAge(this.inputVal)
        return (age > 17 && age < 100)
      }
      return false
    },
    ...mapState({
      history: state => state.history,
      currentStep: state => state.currentStep,
      showInput: state => state.showInput
    })
  },
  mounted () {
    this.addMask()
    if (this.history[this.currentStep].value) this.inputVal = this.history[this.currentStep].value.split('-').join('/')
    this.updateValue()
  },
  methods: {
    handleKeydown (e) {
      if (e.keyCode === 13) {
        this.$store.dispatch('nextStepPrepare', +1)
      }
    },
    handleChange (e) {
      this.inputVal = e.target.value
    },
    addMask () {
      if (this.im.remove) this.im.remove()
      const options = {}
      if (this.newDesign) options.placeholder = this.history[this.currentStep].field.placeholder
      this.im = new Inputmask('99/99/9999', options)
      setTimeout(() => {
        this.im.mask(document.getElementsByName(this.history[this.currentStep].name)[0])
      }, 50)
    },
    updateValue () {
      // feature for get new value after inserting data and updating with inputmask
      setTimeout(() => {
        let selector = document.getElementsByName(this.history[this.currentStep].name)[0]
        if (selector) this.inputVal = selector.value
      }, 150)
    }
  },
  watch: {
    inputVal: function (val, oldVal) {
      this.$store.commit('UPDATE_FIELD', { isValid: this.isValid, value: val.split('/').join('-') })
    },
    showInput: function (val, oldVal) {
      if (val) {
        this.$nextTick(function () {
          this.addMask()
        })
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/fields/DateField.vue